<template>
  <search-group-form-page
      :resource-name="resourceName"
      :url="`projects/${project_id}/searches/group_library`"
      :item_id="null"
      :item="model"
      :title="$t('booleanSearch.new_bool_group')"
      :detail-fields="['name', 'boolDescription']"
      :hide-filters="true"
      :is-busy="isBusy"
  />
</template>

<script>

// Const
import { groupQuery } from '../../config/bool-const'

// Components
import SearchGroupFormPage from "../../components/boolean-search/SearchGroupFormPage.vue";

export default {
  name: "create-group",

  data() {
    return {
      resourceName: 'group_library',
      model: { ...groupQuery },
    }
  },

  computed: {
    project_id() { return this.$store.state.booleanSearch.project_id },
    isBusy() { return this.$store.state.booleanSearch.isBusy },
  },

  components: {
    SearchGroupFormPage,
  }
}
</script>